import React, { useState, useEffect } from "react";
import PARSE from "html-react-parser";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";
import * as yup from "yup";
import Api from "./Api";
import GlobalApi from "../../context/api/GlobalApi";
import "./SSoft_Contact_Us_Form.css";
import { FormControl, Select, MenuItem } from "@mui/material";

const validOptions = ["Consultation", "Request Demo", "Sales"];

function SSoft_Contact_Us_Form() {
  const activeLang = useSelector((state) => state.content.activeLanguage);
  const topicStore = useSelector((state) => state.TopicStore);

  const schema = yup.object().shape({
    firstName: yup.string(),
    lastName: yup.string(),
    email: yup
      .string()
      .email(activeLang === 3 ? "format email salah" : "Invalid email")
      .required(
        activeLang === 3 ? "wajib sertakan email" : "Email is required"
      ),
    phoneNumber: yup
      .number()
      .typeError(
        activeLang === 3
          ? "wajib sertakan Nomor Telepon"
          : "Phone Number is required"
      )
      .required(),
    topic: yup
      .string()
      .required(
        activeLang === 3 ? "wajib sertakan Topik" : "Topic is required"
      ),
    solution: yup.string().when("topic", {
      is: (val) => validOptions.includes(val),
      then: (schema) =>
        schema.required(
          activeLang === 3 ? "wajib sertakan solution" : "solution is required"
        ),
      otherwise: (schema) => schema.nullable(),
    }),
    Inquiry: yup.string(),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [sectionItems, setSectionItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState(
    topicStore?.topicOptionValue || ""
  );
  const [openSolutionsSelect, setOpenSolutionsSelect] = useState(
    validOptions.includes(topicStore?.topicOptionValue)
  );
  const [solutionSelect, setSolutionSelect] = useState(
    topicStore?.solutionOptionValue || ""
  );
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [checkAcceptTerms, setCheckAcceptTerms] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({
        language: activeLang,
      });
      const sectionData = sectionResponse.data.results[0].widgets;
      setSectionItems(sectionData);
    };

    fetchData();
  }, [activeLang]);

  useEffect(() => {
    if (acceptTerms) {
      setCheckAcceptTerms(null);
    }
  }, [acceptTerms]);

  let title;
  const inputLabels = [];
  const optionList = [];
  const solutionList = [];
  let optionsLabel;
  let messageLabel;
  let solutionsLabel;
  let terms;
  let buttonText;
  let successText;
  if (sectionItems) {
    if (sectionItems) {
      sectionItems?.forEach((data, id) => {
        const { widget_contents } = data;
        switch (id) {
          case 0:
            title = widget_contents[0]?.content;
            break;
          case 1:
            inputLabels.push(...widget_contents);
            break;
          case 2:
            optionsLabel = widget_contents[0]?.article_language?.content;
            messageLabel = widget_contents[1]?.article_language?.content;
            buttonText = widget_contents[3]?.article_language?.title;
            solutionsLabel = widget_contents[4]?.article_language?.content;

            const termsData = { ...widget_contents[2]?.article_language };
            const termsUrl = termsData?.path;

            const transformedContent = termsData?.content
              .replace('<a href="">', `<a href=${termsUrl}>`)
              .replace("<p>", `<p class="font-inter">`);

            terms = transformedContent;
            break;
          case 3:
            successText = widget_contents[0]?.content;
            break;
          case 4:
            widget_contents?.map((data) =>
              optionList.push(data?.article_language)
            );
            break;
          case 5:
            widget_contents?.map((data) =>
              solutionList.push(data?.article_language)
            );
            break;
          default:
            break;
        }
      });
    }
  }

  const handleSelectChange = (event) => {
    const { value } = event?.target;

    setSelectedOption(value);
    setOpenSolutionsSelect(validOptions.includes(value));
  };

  const onSubmit = async (data) => {
    const api = new GlobalApi();
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      topic,
      inquiry,
      solution,
    } = data;

    const mailData = {
      language: activeLang,
      email_data: {
        first_name: firstName,
        last_name: lastName,
        phone: phoneNumber,
        email: email,
        topic: topic,
        inquiry: inquiry,
        ...(solution && { solution: solution }),
      },
      email_content: 21,
    };

    try {
      if (acceptTerms) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_submit",
          form_name: "contact_us_form",
        });
        await api.sendEmail(mailData);
        Swal.fire("", successText, "success");
        resetForm();
      } else {
        setCheckAcceptTerms(
          <p className="text-cuzRed">
            {activeLang === 3
              ? "Silahkan setujui persyaratan"
              : "Please check to agree to the terms."}
          </p>
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const resetForm = () => {
    reset();
    setSelectedOption("");
    setSolutionSelect("");
    setOpenSolutionsSelect(false);
    setAcceptTerms(false);
  };

  return (
    sectionItems && (
      <div className="w-full h-full bg-[#FAF8F5]">
        <div className="section-container section-margin-x py-[80px] lg:py-[120px] xl:px-[120px] max-w-[1200px]">
          <div className="space-y-[60px]">
            <div className="flex flex-col items-center self-stretch justify-center">
              <h1 className="flex text-center header-style-non-hero w-full md:w-[630px]">
                {title}
              </h1>
            </div>
            <div className="w-full mdl:grid mdl:justify-center">
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="w-full mdl:min-w-[768px] space-y-[24px]"
              >
                <div className="w-full grid grid-cols-1 s:grid-cols-2 gap-[24px]">
                  {inputLabels &&
                    inputLabels.map((data) => {
                      const { article_language, name } = data;

                      return (
                        <div
                          key={data.id}
                          className="grid grid-cols-1 gap-y-[8px]"
                        >
                          <label
                            htmlFor={article_language?.slug_title}
                            className="s:flex gap-x-2 gap-y-2 s:gap-y-0 font-inter"
                          >
                            {PARSE(article_language?.content)}
                            {errors[name] && (
                              <p className="text-cuzRed">
                                {errors[name].message}
                              </p>
                            )}
                          </label>
                          <input
                            {...register(`${name}`)}
                            type={name === "phoneNumber" ? "number" : "text"}
                            id={article_language?.slug_title}
                            className={`w-full border p-2 bg-transparent border-black`}
                          />
                        </div>
                      );
                    })}
                </div>

                <div className="space-y-[8px] w-full">
                  <label
                    htmlFor="topic"
                    className="s:flex gap-x-2 gap-y-2 s:gap-y-0 font-inter"
                  >
                    {optionsLabel && PARSE(optionsLabel)}
                    {errors.topic && (
                      <p className="text-cuzRed">{errors.topic.message}</p>
                    )}
                  </label>

                  <FormControl fullWidth>
                    <Select
                      id="topic"
                      {...register(`topic`)}
                      value={selectedOption || ""}
                      onChange={(e) => {
                        if (handleSelectChange) {
                          handleSelectChange(e);
                        }
                      }}
                      displayEmpty
                      sx={{}}
                      size="small"
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            backgroundColor: "white",
                            color: "white",
                          },
                        },
                      }}
                    >
                      <MenuItem
                        value=""
                        sx={{
                          color: "#0D4052",
                          backgroundColor:
                            selectedOption === "" ? "#3B82F6" : "transparent",
                          "&.Mui-selected": {
                            backgroundColor: "rgba(37, 82, 98, 0.9) !important",
                            color: "white",
                          },
                          "&:hover": {
                            backgroundColor: "#255262",
                            color: "white",
                          },
                          py: "10px",
                        }}
                      >
                        {activeLang !== 3 ? "Select a topic" : "Pilih Topik"}
                      </MenuItem>

                      {optionList &&
                        optionList.map((option) => {
                          return (
                            <MenuItem
                              key={option?.id}
                              value={option?.title}
                              sx={{
                                color: "#0D4052",
                                backgroundColor:
                                  selectedOption === option?.title
                                    ? "#255262"
                                    : "transparent",
                                "&.Mui-selected": {
                                  backgroundColor:
                                    "rgba(37, 82, 98, 0.9) !important",
                                  color: "white",
                                },
                                "&:hover": {
                                  backgroundColor: "#255262",
                                  color: "white",
                                },
                                py: "10px",
                              }}
                            >
                              {PARSE(option?.content)}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
                {openSolutionsSelect && (
                  <div className="space-y-[8px] w-full">
                    <label
                      htmlFor="solution"
                      className="s:flex gap-x-2 gap-y-2 s:gap-y-0 font-inter"
                    >
                      {solutionsLabel && PARSE(solutionsLabel)}
                      {errors.solution && (
                        <p className="text-cuzRed">{errors.solution.message}</p>
                      )}
                    </label>

                    <FormControl fullWidth>
                      <Select
                        id="solution"
                        {...register("solution")}
                        value={solutionSelect || ""}
                        onChange={(e) => setSolutionSelect(e.target.value)}
                        displayEmpty
                        size="small"
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              backgroundColor: "white",
                              color: "white",
                            },
                          },
                        }}
                        sx={
                          {
                            // Add any additional styling here if needed
                          }
                        }
                      >
                        <MenuItem
                          value=""
                          sx={{
                            color: "#0D4052",
                            backgroundColor:
                              solutionSelect === "" ? "#3B82F6" : "transparent",
                            "&.Mui-selected": {
                              backgroundColor:
                                "rgba(37, 82, 98, 0.9) !important",
                              color: "white",
                            },
                            "&:hover": {
                              backgroundColor: "#255262",
                              color: "white",
                            },
                            py: "10px",
                          }}
                        >
                          {activeLang !== 3
                            ? "Select a solution"
                            : "Pilih Solusi"}
                        </MenuItem>

                        {solutionList &&
                          solutionList.map((solution) => (
                            <MenuItem
                              key={solution?.id}
                              value={solution?.title}
                              sx={{
                                color: "#0D4052",
                                backgroundColor:
                                  solutionSelect === solution?.title
                                    ? "#255262"
                                    : "transparent",
                                "&.Mui-selected": {
                                  backgroundColor:
                                    "rgba(37, 82, 98, 0.9) !important",
                                  color: "white",
                                },
                                "&:hover": {
                                  backgroundColor: "#255262",
                                  color: "white",
                                },
                                py: "10px",
                              }}
                            >
                              {PARSE(solution?.content)}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                )}
                <div className="grid grid-cols-1 space-y-[8px]">
                  <label htmlFor="message" className="font-inter">
                    {messageLabel && PARSE(messageLabel)}
                  </label>
                  <textarea
                    id="message"
                    {...register(`inquiry`)}
                    className="border border-black p-2 w-full h-[180px] bg-transparent"
                    rows="4"
                  ></textarea>
                </div>
                <div className="w-full space-y-[24px] justify-center">
                  {terms && (
                    <div className="flex flex-col items-center justify-center relative gap-y-2">
                      <div className="flex items-center justify-center relative">
                        <label className="container w-fit font-inter">
                          <input
                            type="checkbox"
                            id="termsCheckbox"
                            className="bg-transparent checkbox-transparent"
                            checked={acceptTerms}
                            onClick={() => setAcceptTerms(!acceptTerms)}
                          />
                          <span className="checkmark border border-black"></span>
                        </label>
                        <p>{PARSE(terms)}</p>
                      </div>
                      {checkAcceptTerms}
                    </div>
                  )}
                  <div className="flex justify-center">
                    {buttonText && (
                      <button
                        type="submit"
                        className="py-[12px] px-[25px] bg-red-500 text-white rounded-[8px] cursor-pointer"
                      >
                        <p className="text-[16px] font-inter font-semibold">
                          {buttonText}
                        </p>
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default SSoft_Contact_Us_Form;
